import React from 'react'
import { useTranslation } from 'react-i18next'

import cn from 'classnames'
import i18next from 'i18next'

import { CustomButton, Icon } from 'src/components/ui'

import styles from './ChangeLanguagePage.module.scss'
import { useLanguages } from './utils/useLanguages'

interface Props {
  className?: string
}

export const ChangeLanguagePage: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation()
  const LANGUAGES = useLanguages(t)
  const [activeLanguage, setActiveLanguage] = React.useState(i18next.language)

  const changeAppLanguage = () => {
    localStorage.setItem('language_code', activeLanguage)
    i18next.changeLanguage(activeLanguage)
  }

  return (
    <div className={cn(styles.container, className)}>
      {LANGUAGES.map((language) => (
        <CustomButton
          key={language.code}
          className={styles.language_button}
          variant='contained'
          color='white'
          onClick={() => setActiveLanguage(language.code)}
        >
          <p>{language.name}</p>
          {activeLanguage === language.code && (
            <div className={styles.active}>
              <Icon name='check_mark' />
            </div>
          )}
        </CustomButton>
      ))}

      <CustomButton
        className={styles.button}
        variant={activeLanguage !== i18next.language ? 'contained' : 'not-active'}
        color='violet'
        onClick={changeAppLanguage}
      >
        {t('language_page.choose')}
      </CustomButton>
    </div>
  )
}
